import { FC, PropsWithChildren, ReactElement } from 'react'

import './Card.scss'

interface CardProps extends PropsWithChildren {
    className?: string;
}

const Card: FC<CardProps> = ({
    className = '',
    children,
}): ReactElement => (
    <section className={`card ${className}`}>
        {children}
    </section>
)

export default Card
